import { useEffect, useState } from 'react';
import type { SlotDemoScene } from '@goodtime/engine';
import type { CollectState } from '@goodtime/shared';
import { fetchCollect } from '../../api/collect';

/**
 * Reel collectibles on the open slot (`reel_collect`), mounted by App on
 * every slot whatever the player's features: the server says which slots
 * have relics (every rr_v1 slot) and answers 204 for the rest. It draws
 * nothing: it loads the slot's relics when the slot opens and hands them to
 * the slot scene, which draws the shelf on its canvas and plays each spin's
 * finds from the spin's own answer.
 */
export function SlotRelics({
  scene,
  sessionId,
  themeId,
}: {
  scene: SlotDemoScene | null;
  sessionId: string | null;
  themeId: string;
}) {
  const [state, setState] = useState<CollectState | null>(null);

  useEffect(() => {
    setState(null);
    if (!sessionId) return;
    let cancelled = false;
    void fetchCollect(sessionId, themeId).then((s) => {
      if (!cancelled) setState(s);
    });
    return () => {
      cancelled = true;
    };
  }, [sessionId, themeId]);

  useEffect(() => {
    if (state) scene?.setRelics({ themeId, state });
  }, [scene, state, themeId]);

  // Gone (another scene): the shelf goes too.
  useEffect(() => () => scene?.setRelics(null), [scene]);

  return null;
}
